import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";
import Label from "sap/m/Label";
import FormattedText from "sap/m/FormattedText";

/**
 * @namespace vamos.cockpit.data.masterdata.bmecat.discontinueditems.control
 */

export default class InfoItem extends Control {

    static readonly metadata: MetadataOptions = {
        properties: {
            icon: { type: "string", defaultValue: "" },
            text: { type: "string", defaultValue: "" },
            additionalText: { type: "string", defaultValue: "" },
        },
        aggregations: {
            _icon: { type: "sap.ui.core.Icon", multiple: false, visibility: "hidden" },
            _text: { type: "sap.m.FormattedText", multiple: false, visibility: "hidden" },
            _additionalText: { type: "sap.m.Label", multiple: false, visibility: "hidden" },
        },
    };

    static renderer = {
        apiVersion: 4,
        render: (rm: RenderManager, control: InfoItem) => {
            rm.openStart("div", control);
            rm.class("productInfoItem");
            rm.openEnd();

            rm.renderControl(control.getAggregation("_icon") as Control);

            rm.openStart("div");
            rm.class("productInfoItemText");
            rm.openEnd();
            rm.renderControl(control.getAggregation("_text") as Control);
            rm.renderControl(control.getAggregation("_additionalText") as Control);
            rm.close("div");

            rm.close("div");
        },
    };

    init(): void {
        this.setAggregation("_icon", new Icon(
            {
                size: "1.5rem"
            }));
        this.setAggregation("_text", new FormattedText());
        this.setAggregation("_additionalText", new Label());
    }

    setIcon(value: string): this {
        this.setProperty("icon", value, true);
        (this.getAggregation("_icon") as Icon).setSrc(value);
        return this;
    }

    setText(value: string): this {
        this.setProperty("text", value, true);
        (this.getAggregation("_text") as FormattedText).setHtmlText(value);
        return this;
    }

    setAdditionalText(value: string): this {
        this.setProperty("additionalText", value, true);
        (this.getAggregation("_additionalText") as Label).setText(value);
        return this;
    }
    getIcon(): string {
        return this.getProperty("icon") as string;
    }
}
